import cn from 'classnames';
import { useFlag } from './use-flag';
import type { Flag } from '../../types';
import css from './flag.module.scss';

interface Props {
    flag: Flag;
}
export function FeatureFlag({ flag }: Props) {
    const { value, onChange, isOverride, link } = useFlag(flag);

    return (
        <div className={css.flag}>
            <div>
                <a target="_blank" className={css.name} href={link}>
                    {flag.key}
                </a>

                <div className={css.tags}>
                    <span className={cn(css.tag, { [css.ab]: flag.isAbTest })}>
                        {flag.isAbTest ? '✦ A/B Test' : '❖ Targeted Delivery'}
                    </span>

                    {isOverride && (
                        <span className={cn(css.tag, css.override)}>
                            ∅ override
                        </span>
                    )}
                </div>
            </div>

            <select
                id={flag.id}
                value={value}
                className={css.select}
                onChange={onChange}
            >
                <button>
                    {/* @ts-expect-error -- new api */}
                    <selectedcontent></selectedcontent>
                    <span className={css.icon}>⌃</span>
                </button>
                {flag.options.map(o => (
                    <option
                        key={o}
                        value={o}
                        className={cn(css.option, {
                            [css.selected]: o === value,
                        })}
                    >
                        {o}
                    </option>
                ))}
            </select>
        </div>
    );
}
